import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { findRouteTitle } from '../utils/site';

const usePageTitle = () => {
  const location = useLocation();
  const [pageTitle, setPageTitle] = useState(document.title);

  useEffect(() => {
    const newTitle: string = findRouteTitle(location.pathname);
    document.title = newTitle;
    setPageTitle(newTitle);
  }, [location]);

  return pageTitle;
};

export default usePageTitle;
